import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '',
          redirect: '/home' // 将根路径的重定向改为 ''
        },
        {
          path: 'home', // 去掉开头的 '/'，成为相对路径
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        },
        {
          path: 'software', // 去掉开头的 '/'，成为相对路径
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '产品展厅'
          },
          children: [
            {
              path: '', // 将重定向路径改为 ''
              redirect: 'software_products01' // 设定相对路径的重定向
            },
            {
              path: 'software_products01', // 去掉开头的 '/'
              name: 'Software_Products01',
              component: resolve => require(['@/view/Software_Products01'], resolve),
              meta: {
                title: '产品展厅丨床垫'
              }
            },
            {
              path: 'software_products02', // 去掉开头的 '/'
              name: 'Software_Products02',
              component: resolve => require(['@/view/Software_Products02'], resolve),
              meta: {
                title: '产品展厅丨沙发'
              }
            }
          ]
        },
        {
          path: 'service', // 去掉开头的 '/'
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        },
        {
          path: 'newsinformation', // 去掉开头的 '/'
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: 'companyintroduction', // 去掉开头的 '/'
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '企业简介'
          }
        },
        {
          path: 'jobchance', // 去掉开头的 '/'
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        },
        {
          path: 'contactus', // 去掉开头的 '/'
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: 'servicedetail', // 去掉开头的 '/'
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ]
});

// const VueRouterPush = Router.prototype.push
// Router.prototype.push = function push (to) {
//   return VueRouterPush.call(this, to).catch(err => err)
// }



// WEBPACK FOOTER //
// ./src/router/index.js